<template>
  <el-dialog :title="dialogTitle" :visible.sync="baselPlanInfoVisible" class="dialog_block" width="600" height="500" :close-on-click-modal="false">
    <el-form
      ref="daohuoPlanForm"
      label-width="100px"
      class="demo-dynamic"
    >
      <el-form-item :label="typeName+'日期'" prop="planDate">
        {{basePlanInfo.planDate}}
      </el-form-item>
      <el-form-item :label="typeName+'内容'" prop="content">
        {{basePlanInfo.content}}
      </el-form-item>



    </el-form>

    <hr>

  </el-dialog>
</template>

<script>
import { objKeySort } from "@/util/ajaxsign";
export default {
  name: "basePlanInfo",
  data() {
    return {
      baselPlanInfoVisible: false,
      dialogTitle: this.typeName+"计划",
      typeId:0,
      basePlanInfo: {
        id: "",
        content: "",
        planDate: ""
      },
    };
  },
  props:{
    typeName:String,
    required:true,
    default:function(){
      return "勘查"
    }
  },
  created() {

  },
  filters: {

  },
  methods: {



    setData(type,data) {
      this.baselPlanInfoVisible = true;
      this.typeId = type;
      let typeName = "勘察";
      switch (type){
        case 1 : typeName = "勘察"; break;
        case 4 : typeName = "验收"; break;
        case 5 : typeName = "回访"; break;
        default :
          alert("类型参数错误");return;
      }
      this.typeName = typeName;
      this.dialogTitle = typeName+"计划";
      this.basePlanInfo = data;
    },


    close() {
      this.baselPlanInfoVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
  .mb_7{
    margin-bottom: 7px;
  }
  .width_80{
    width: 80px;
    margin-top: 0;
  }
  .el-button{
   padding: 1px 16px;
  }
  .el-upload--picture-card{
    width: 125px;
    height: 125px;
    border-radius:3px;
    border:1px solid rgba(237,239,242,1);
    img{
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }
  }
  .el-upload-list__item{
    img{
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }
  }

  .foot_span{
    text-align: right;
    margin-right: 56px;
  }
  hr {
    bottom: 72px;
    border-color: rgba(245, 247, 250, 0.2);
    margin-bottom: 15px;
  }
  .el-dialog__body{
    padding: 0 !important;
  }
  .el-upload-list__item:first-child{
    margin-top: 0 !important;
  }
  .el-form-item{
    margin-bottom: 0px!important;
  }
</style>
